import React from 'react'

import { ComponentWithSubheader } from 'dash/shared'
import { NotificationList } from './list'

export default class Notification {
  static List = () => (
    <ComponentWithSubheader path={['My Account']} label="Notifications" component={NotificationList} />
  )
}
